// @flow
const tableStyle = {
  marginTop: '25px',
  background: '#f8f8f8',
  borderRadius: '5px',
};

export default {
  tableStyle,
};



// WEBPACK FOOTER //
// ./src/scenes/Admins/components/AdminList/style.js